import { Reducer } from "redux";

import { EligibilityInformationActionDispatchTypes } from "../constants/ReferralRequestor";
import { EligibilityInformationResponse } from "../models/Api/CheckEligibility";
import { EligibilityInformationDispatchTypes } from "../models/DispatchTypes/CheckEligibility";

const initialState: EligibilityInformationResponse = {
    loading: false,
    response: {
        lastName: "",
        dob: "",
        policyId: "",
        payerId: "",
        payerName: "",
        firstName: "",
        eligibilityId: 0,
        eligibilityStatus: "",
        isBcbsmiAuth:  null,
        response:  null,
    },
};

const EligibilityInformation: Reducer<EligibilityInformationResponse, EligibilityInformationDispatchTypes> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
    }
    return state;
};

export default EligibilityInformation;